import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
    homeTags: null,
}
const sortTagsAlphabetically = (tags: any[]) => {
    return tags.sort((a, b) => a.label.localeCompare(b.label));
};

export const homeTagsSlice = createSlice({
    name: 'homeTags',
    initialState,
    reducers: {
        setHomeTags: (state, action) => {
            state.homeTags = sortTagsAlphabetically(action.payload);
        },
        addHomeTags: (state, action) => {
            action.payload.forEach((newTag: any) => {
                const existingTag = state.homeTags.find((tag: any) => tag.value === newTag.value);

                if (existingTag) {
                    const currentCount = Number(existingTag.count || 0);
                    existingTag.count = (currentCount + 1).toString();
                } else {
                    state.homeTags = state.homeTags
                        ? [...state.homeTags, { ...newTag, count: "1" }]
                        : [{ ...newTag, count: "1" }];
                }
                state.homeTags = sortTagsAlphabetically(state.homeTags);
            });
        },


        removeHomeTags: (state, action) => {
            action.payload.forEach((removeTag: any) => {
                const existingTag = state.homeTags.find((tag: any) => tag.value === removeTag);

                if (existingTag) {
                    const currentCount = Number(existingTag.count || 0);

                    if (currentCount > 1) {
                        existingTag.count = (currentCount - 1).toString();
                    } else {
                        state.homeTags = state.homeTags?.filter((tag: any) => tag.value !== removeTag);
                    }
                }
                state.homeTags = sortTagsAlphabetically(state.homeTags);
            });
        },

    },
})

export const { setHomeTags, addHomeTags, removeHomeTags } = homeTagsSlice.actions

export default homeTagsSlice.reducer
